export const RESERVATION_AGENT_ROLE = 'reservation_manager';

export const RESERVATION_AGENT_LABELS = Object.freeze({
  dashboard: 'My Dashboard',
  leads: 'My Leads',
  chats: 'My Chats',
  calendar: 'My Calendar',
  inbox: 'My Email',
  bookingsSection: 'My Bookings',
  approvals: 'My Change Requests',
  villaInventory: 'Villa Inventory',
  contacts: 'Contacts Directory',
});

const ADMIN_PATH_PREFIXES = Object.freeze([
  '/owner-payouts',
  '/global-owner-payouts',
  '/non-exclusive-payouts',
  '/transactions',
  '/reports-export',
  '/exclusive-reports',
  '/non-exclusive-reports',
  '/agent-commissions',
  '/import',
  '/admin/contract-templates',
  '/admin/contract-clauses',
  '/admin/templates',
  '/settings',
  '/tiers',
]);

const SETTINGS_EXCEPTION_PREFIXES = Object.freeze([
  '/settings/email-signature',
  '/settings/connected-mailboxes',
]);

const WORKSPACE_PATH_PREFIXES = Object.freeze([
  '/dashboard',
  '/leads',
  '/live-chats',
  '/exclusive-dashboard',
  '/non-exclusive-bookings-dashboard',
  '/non-exclusive-bookings',
  '/calendar',
  '/inbox',
  '/guest-preferences',
  '/villas',
  '/agents',
  '/agencies',
  '/owners',
  '/vendors',
  '/approvals',
  '/employee-dashboard',
  '/settings/email-signature',
  '/settings/connected-mailboxes',
  '/profile',
]);

const normalizePath = (path) => {
  if (!path || typeof path !== 'string') return '/';
  return path.split(/[?#]/)[0].replace(/\/+$/, '') || '/';
};

const matchesPrefix = (path, prefix) => {
  const normalizedPath = normalizePath(path);
  const normalizedPrefix = normalizePath(prefix);
  return normalizedPath === normalizedPrefix || normalizedPath.startsWith(`${normalizedPrefix}/`);
};

export const isReservationAgentRole = (userOrRole) => {
  const role = typeof userOrRole === 'string' ? userOrRole : userOrRole?.role;
  return role === RESERVATION_AGENT_ROLE;
};

export const getReservationAgentLabels = () => ({ ...RESERVATION_AGENT_LABELS });

export const isReservationAgentAdminPath = (path) =>
  !SETTINGS_EXCEPTION_PREFIXES.some((prefix) => matchesPrefix(path, prefix)) &&
  ADMIN_PATH_PREFIXES.some((prefix) => matchesPrefix(path, prefix));

export const isReservationAgentWorkspacePath = (path) => {
  if (isReservationAgentAdminPath(path)) return false;
  return WORKSPACE_PATH_PREFIXES.some((prefix) => matchesPrefix(path, prefix));
};

export const canShowReservationAgentFinancialAdmin = (userOrRole) =>
  !isReservationAgentRole(userOrRole);
